import React from "react";

export default function Sales() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">Sales</h2>
        </div>
      </div>
    </div>
  );
}
